import React, {useContext, useState} from 'react';
import './ModalNewUser.css'
import {Context} from "../../index";
import {fetchUsers} from "../../http/UserAPI";

const ModalNewUser = ({active, setActive, errLogin, setErrLogin, setAllUsers}) => {

    const {userStore} = useContext(Context)

    const [nickname, setNickname] = useState('')
    const [password, setPassword] = useState('')
    const [firstName, setFirstName] = useState('')
    const [secondName, setSecondName] = useState('')
    const [userRole, setUserRole] = useState('USER')

    const signIn = () => {
        userStore.addOneUser(nickname.toLowerCase(), password, firstName, secondName, userRole, setErrLogin)
        fetchUsers().then(data => setAllUsers(data))
        setActive(false)
        setNickname('')
        setPassword('')
        setFirstName('')
        setSecondName('')
    }

    return (
        <div className={active ? "modal active" : "modal"} onClick={() => setActive(false)}>
            <div className={active ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h2>Новый пользователь</h2>

                <div className="email">
                    <label htmlFor="email">Логин</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setNickname(e.target.value)} type="text" name="nickname"
                               placeholder="Login"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="password">Пароль</label>
                    <div className="sec-2">
                        <ion-icon name="lock-closed-outline"></ion-icon>
                        <input onChange={e => setPassword(e.target.value)} className="pas" type="password"
                               name="password" placeholder="············"/>
                        <ion-icon className="show-hide" name="eye-outline"></ion-icon>
                    </div>
                    {password.length < 6 && password !== '' ?
                        <h5>Пароль меньше шести символов!</h5>
                        : null
                    }
                </div>
                <div className="password">
                    <label htmlFor="email">Фамилия</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setFirstName(e.target.value)} type="text" name="lastName"
                               placeholder="Фамилия"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="email">Имя</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setSecondName(e.target.value)} type="text" name="secondName"
                               placeholder="Имя"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="email">Роль</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <select onChange={e => setUserRole(e.target.value)} value={userRole}
                                className="select__css__modal">
                            {userStore.role.map(role =>
                                <option
                                    onClick={() => setUserRole(role)}
                                    key={role.id}
                                    value={role.id}
                                >
                                    {role.value}
                                </option>
                            )}
                        </select>
                    </div>
                </div>

                <div className="btn__new__user__block">
                    {nickname !== '' && password.length > 5 && firstName !== '' && secondName !== ''
                        ?
                        <button className="btn__yes" onClick={signIn}>Создать</button>
                        :
                        <button className="btn__disable">Создать</button>
                    }

                    <div className="cl-btn-6" onClick={() => setActive(false)}>
                        <div className="cl-btn-6-in">
                            <div className="cl-btn-6-txt">Закрыть</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ModalNewUser;